import { Typography } from '@fortress-technology-solutions/fortress-component-library/Atoms';

const StudentAndAssistanceInformationSection = {
  name: 'studentAndAssistanceInformation',
  title: 'STUDENT AND ASSISTANCE INFORMATION',
  container: 'default',
  titleVariant: 'subsection',
  fields: [
    {
      variant: 'radioGroup',
      name: 'areYouAStudent',
      label: 'Are you a current student?',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
      ],
      rules: { required: true },
      changeActions: [
        {
          type: 'updateField',
          target: 'enrollmentStatus',
          when: {
            eq: 'no',
          },
          value: null,
        },
        {
          type: 'updateField',
          target: 'tanfAssistance',
          when: {
            eq: 'no',
          },
          value: null,
        },
        {
          type: 'updateField',
          target: 'jobTraining',
          when: {
            eq: 'no',
          },
          value: null,
        },
        {
          type: 'updateField',
          target: 'singleParentOrDependentChild',
          when: {
            eq: 'no',
          },
          value: null,
        },
        {
          type: 'updateField',
          target: 'marriedJointReturn',
          when: {
            eq: 'no',
          },
          value: null,
        },
        {
          type: 'updateField',
          target: 'fosterProgram',
          when: {
            eq: 'no',
          },
          value: null,
        },
      ],
      sx: {
        flexDirection: 'row',
      },
      GridProps: {
        xs: 12,
        md: 2,
      },
    },
    {
      variant: 'radioGroup',
      name: 'enrollmentStatus',
      label: 'Enrollment Status',
      options: [
        { label: 'Full-Time K-12', value: 'f_tK_12' },
        { label: 'Full-Time Post 12', value: 'f_tPost12' },
        { label: 'Part-Time', value: 'p_t' },
      ],
      watchFields: ['areYouAStudent'],
      hidden: ({ getValues }) => getValues('areYouAStudent') !== 'yes',
      rules: { required: true },
      changeActions: [
        {
          type: 'updateField',
          target: 'tanfAssistance',
          when: {
            in: ['p_t', null],
          },
          value: null,
        },
        {
          type: 'updateField',
          target: 'jobTraining',
          when: {
            in: ['p_t', null],
          },
          value: null,
        },
        {
          type: 'updateField',
          target: 'singleParentOrDependentChild',
          when: {
            in: ['p_t', null],
          },
          value: null,
        },
        {
          type: 'updateField',
          target: 'marriedJointReturn',
          when: {
            in: ['p_t', null],
          },
          value: null,
        },
        {
          type: 'updateField',
          target: 'fosterProgram',
          when: {
            in: ['p_t', null],
          },
          value: null,
        },
      ],
      sx: {
        flexDirection: 'row',
      },
      GridProps: {
        xs: 12,
        md: 10,
      },
    },
    {
      variant: 'custom',
      component: (
        <Typography variant="bodySmall">
          If Full-Time, select the options below that describes your student
          status:
        </Typography>
      ),
      watchFields: ['enrollmentStatus'],
      hidden: ({ getValues }) =>
        getValues('enrollmentStatus') !== 'f_tK_12' &&
        getValues('enrollmentStatus') !== 'f_tPost12',
      GridProps: {
        xs: 12,
      },
    },
    {
      variant: 'radioGroup',
      name: 'tanfAssistance',
      label: 'TANF Assistance',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
      ],
      rules: { required: true },
      watchFields: ['enrollmentStatus'],
      hidden: ({ getValues }) =>
        getValues('enrollmentStatus') !== 'f_tK_12' &&
        getValues('enrollmentStatus') !== 'f_tPost12',
      sx: {
        flexDirection: 'row',
      },
      GridProps: {
        xs: 12,
        md: 2,
      },
    },
    {
      variant: 'radioGroup',
      name: 'jobTraining',
      label: 'Job Training',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
      ],
      rules: { required: true },
      watchFields: ['enrollmentStatus'],
      hidden: ({ getValues }) =>
        getValues('enrollmentStatus') !== 'f_tK_12' &&
        getValues('enrollmentStatus') !== 'f_tPost12',
      sx: {
        flexDirection: 'row',
      },
      GridProps: {
        xs: 12,
        md: 2,
      },
    },
    {
      variant: 'radioGroup',
      name: 'singleParentOrDependentChild',
      label: 'Single Parent/Dependent Child',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
      ],
      rules: { required: true },
      watchFields: ['enrollmentStatus'],
      hidden: ({ getValues }) =>
        getValues('enrollmentStatus') !== 'f_tK_12' &&
        getValues('enrollmentStatus') !== 'f_tPost12',
      sx: {
        flexDirection: 'row',
      },
      GridProps: {
        xs: 12,
        md: 3,
      },
    },
    {
      variant: 'radioGroup',
      name: 'marriedJointReturn',
      label: 'Married/Joint Return',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
      ],
      rules: { required: true },
      watchFields: ['enrollmentStatus'],
      hidden: ({ getValues }) =>
        getValues('enrollmentStatus') !== 'f_tK_12' &&
        getValues('enrollmentStatus') !== 'f_tPost12',
      sx: {
        flexDirection: 'row',
      },
      GridProps: {
        xs: 12,
        md: 2,
      },
    },
    {
      variant: 'radioGroup',
      name: 'fosterProgram',
      label: 'Foster Program',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
      ],
      rules: { required: true },
      watchFields: ['enrollmentStatus'],
      hidden: ({ getValues }) =>
        getValues('enrollmentStatus') !== 'f_tK_12' &&
        getValues('enrollmentStatus') !== 'f_tPost12',
      sx: {
        flexDirection: 'row',
      },
      GridProps: {
        xs: 12,
        md: 3,
      },
    },
  ],
};

export default StudentAndAssistanceInformationSection;
